import {
  HIDE_POSITIONS_LOADER,
  SET_ERROR_POSITIONS,
  SET_POSITIONS,
  SET_POSITIONS_FOR_ID,
  SET_POSITIONS_FOR_ADD,
  SHOW_POSITIONS_LOADER,
  SET_GROUPS,
} from "./actionType";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    title: "",
    results: [],
  },
  groups: [],
  dataForAddBudget: null,
  client_position: null,
  isError: false,
  loading: false,
  error: null,
};

const Positions = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_POSITIONS:
      return {
        ...state,
        data: action.payload,
      };
    case SET_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case SET_POSITIONS_FOR_ADD:
      return {
        ...state,
        groups: action.payload,
      };
    case SET_POSITIONS_FOR_ID:
      return {
        ...state,
        client_position: action.payload,
      };
    case SHOW_POSITIONS_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_POSITIONS_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR_POSITIONS:
      return {
        ...state,
        isError: action.payload,
      };
    default:
      return state;
  }
};

export default Positions;
